import { cssPlayerHeightUnit } from '../../../utility/constants'

export const EMPTY_SPACE = '#14163D'
export const PRIMARY_PURPLE = '#6a4983'
export const PRIMARY_GREEN = '#629b98'

export const EOMS_LIGHT = '#8A87BF'
export const EOMS_DARK = '#676495'
export const EOMS_DARK_HIGHLIGHT = '#2e2c62'

export const EOMS_BACKGROUND = `${EOMS_DARK}9F`
export const EOMS_BORDER_WIDTH = 0.5
export const EOMS_BORDER = `${cssPlayerHeightUnit(
	EOMS_BORDER_WIDTH
)} solid white`
export const EOMS_BORDER_RADIUS: string = cssPlayerHeightUnit(0.5)
